import {Component, OnInit, Input, forwardRef} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';


@Component({
    selector: 'app-input',
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => InputComponent),
        multi: true
    }]
})
export class InputComponent implements OnInit, ControlValueAccessor {
    private innerValue = '';
    private onTouchedCallback: () => void;
    private onChangeCallback: (value: string) => void;

    @Input() public type: string;
    @Input() public name: string;
    @Input() public id: string;
    @Input() public placeholder = '';

    constructor() {
    }

    get value(): string {
        return this.innerValue;
    }

    set value(value: string) {
        if (value !== this.innerValue) {
            this.innerValue = value;
            this.onChangeCallback(value);
        }
    }

    ngOnInit() {
    }

    writeValue(value: string) {
        if (value !== this.innerValue) {
            this.innerValue = value;
        }
    }

    registerOnChange(fn: (value: string) => void) {
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn: () => void) {
        this.onTouchedCallback = fn;
    }
}
